/**
 * Leaf module for mobile experience detection. Extracted so callers that
 * need only the detection check (e.g. mixpanel tracking) do not pull in the
 * full `deviceDetection` module, which would create an import cycle.
 */

import Cookies from "js-cookie";

const MOBILE_COOKIE_NAME = "ig-mobile";

const isMobileDevice = (): boolean => {
  if (typeof window === "undefined" || !window.navigator) {
    return false;
  }

  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/User-Agent/Firefox#device-specific_user_agent_strings
  return window.navigator.userAgent.toLowerCase().includes("mobi");
};

const getMobilePreference = (): boolean | null => {
  try {
    const cookieValue = Cookies.get(MOBILE_COOKIE_NAME);
    if (cookieValue === "true") {
      return true;
    }
    if (cookieValue === "false") {
      return false;
    }
    return null;
  } catch (error) {
    console.warn("Unable to access cookie:", error);
    return null;
  }
};

/**
 * Determines if the mobile experience should be shown
 * Returns true if:
 * - Cookie is explicitly set to "true", OR
 * - Device is mobile AND cookie is not explicitly set to "false"
 */
export const shouldShowMobileExperience = (): boolean => {
  const mobilePreference = getMobilePreference();

  if (mobilePreference !== null) {
    return mobilePreference;
  }

  return isMobileDevice();
};
